import styled from 'styled-components'

export const ValueContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: var(--font-size-normal);

    &.enable-edit {
        padding: 0 8px;
    }

    &.overflow {
        max-width: calc(100%);
        overflow: hidden;
        white-space: nowrap;
    }
`

export const ValuePreview = styled.div`
    position: relative;
    overflow: hidden;
    width: 100%;
    /* 添加height 100% 时会导致画廊label被截断 */
    /* width: 100%;
    height: 100%; */
`
